/* eslint-disable no-unused-vars */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-len */
import React, { useContext, useState, useCallback, useMemo } from 'react';
import { Grid, MenuItem, Select, Stack, styled, Typography, Box, SelectChangeEvent } from '@mui/material';
import CustomSwitch from '../../../../../../../../BussinessCertification/components/CustomSwitch';
import SelectSearchParticipants from '../../../../SelectSearchParticipants';
import { LanguageContext } from '../../../../../../../../../../../libs/Context';
import useContentPermissions from '../../../../ContentCards/useContentPermissions';

// Define interface for access control data structure
interface AccessControlData {
	internalEmployees?: {
		allSelected?: boolean;
		departments?: Array<{name: string; count?: number}>;
		specificUsers?: Array<{userId: string; name: string; email: string; role?: string}>;
	};
	userGroups?: Array<{type: string; count?: number}>;
	participantCount?: number;
	participantLimit?: number;
}

// Define props interface for AccessSlider
interface AccessSliderProps {
	visibility?: 'public' | 'private'|'';
	allowDownload?: boolean;
	allowShare?: boolean;
	accessControl?: AccessControlData;
	onChange?: (data: {
		visibility?: 'public' | 'private';
		allowDownload?: boolean;
		allowShare?: boolean;
		accessControl?: AccessControlData;
	}) => void;
}

// Combined state interface
interface AccessState {
	visibility: 'public' | 'private';
	allowDownload: boolean;
	allowShare: boolean;
	accessControl: any;
}

const AccessSlider: React.FC<AccessSliderProps> = (props) =>
{
	const { language } = useContext(LanguageContext);
	const { isPrivateShareEnabled, isPublicShareEnabled, isShareEnabled, isDownloadEnabled } = useContentPermissions();

	// Create a function to get default values
	const getDefaultValues = () => ({
		visibility    : isPrivateShareEnabled ? 'private' : 'public',
		allowDownload : isDownloadEnabled,
		allowShare    : isShareEnabled,
		accessControl : {
			internalEmployees : {
				allSelected   : props.visibility?.toLowerCase() === 'private',
				departments   : [],
				specificUsers : []
			},
			userGroups       : [],
			participantCount : 0,
			participantLimit : 100
		}
	});

	// Destructure with defaults
	const {
		visibility = getDefaultValues().visibility,
		allowDownload = getDefaultValues().allowDownload,
		allowShare = getDefaultValues().allowShare,
		accessControl = getDefaultValues().accessControl,
		onChange
	} = props;

	const handleVisibilityChange = useCallback((event: SelectChangeEvent<string>) =>
	{
		const newValue = event.target.value as 'public' | 'private';

		if (onChange && newValue !== visibility)
		{
			onChange({ visibility: newValue });
		}
	}, [ onChange, visibility ]);

	const handleAllowDownloadChange = useCallback((checked: boolean) =>
	{
		if (onChange && checked !== allowDownload)
		{
			onChange({ allowDownload: checked });
		}
	}, [ onChange, allowDownload ]);

	const handleAllowShareChange = useCallback((checked: boolean) =>
	{
		if (onChange && checked !== allowShare)
		{
			onChange({ allowShare: checked });
		}
	}, [ onChange, allowShare ]);

	const handleParticipantsSelected = useCallback((participants: any[]) =>
	{
		const updatedAccessControl = {
			...accessControl,
			internalEmployees : {
				...accessControl.internalEmployees,
				specificUsers : participants.map((user) => ({
					userId : user.userId || user.id,
					name   : user.name,
					email  : user.email,
					role   : user.role
				}))
			}
		};

		if (onChange && JSON.stringify(updatedAccessControl) !== JSON.stringify(accessControl))
		{
			onChange({ accessControl: updatedAccessControl });
		}
	}, [ onChange, accessControl ]);

	const handleDepartmentsSelected = useCallback((category: string, selectedDepartments: Record<string, string[]>) =>
	{
		if (category !== 'Internal Employees' || !onChange) return;

		const departmentNames = selectedDepartments[category] || [];
		const isAllSelected = departmentNames.includes('All');

		const updatedAccessControl = {
			...accessControl,
			internalEmployees : {
				...accessControl.internalEmployees,
				allSelected : isAllSelected,
				departments : isAllSelected
					? []
					: departmentNames.map((name) => ({ name }))
			}
		};

		if (JSON.stringify(updatedAccessControl) !== JSON.stringify(accessControl))
		{
			onChange({ accessControl: updatedAccessControl });
		}
	}, [ onChange, accessControl ]);

	const handleRelationsSelected = useCallback((relations: string[]) =>
	{
		const updatedAccessControl = {
			...accessControl,
			userGroups : relations.map((type) => ({ type }))
		};

		if (onChange && JSON.stringify(updatedAccessControl) !== JSON.stringify(accessControl))
		{
			onChange({ accessControl: updatedAccessControl });
		}
	}, [ onChange, accessControl ]);

	const CustomSelect = styled(Select<string>)({
		backgroundColor                      : '#F4F4F4',
		border                               : 'none',
		borderRadius                         : '4px',
		boxShadow                            : 'none',
		minWidth                             : '220px',
		'& .MuiOutlinedInput-notchedOutline' : {
			border : 'none'
		},
		'&:hover' : {
			backgroundColor : '#3FBBE11A'
		},
		'& .MuiSelect-select' : {
			padding  : '6px 10px',
			fontSize : 'var(--pixel14)'
		}
	});

	return (
		<Grid container width={'100%'} onClick={(e) => e.stopPropagation()}>
			{/* {isDownloadEnabled && ( */}
			<Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} width={'100%'}>
				<Typography fontWeight={'var(--font500)'}>{language?.allowDwld}</Typography>
				<CustomSwitch
					toggleEnabled={allowDownload}
					handleToggleChange={(e) => handleAllowDownloadChange(e.target.checked)}
				/>
			</Stack>
			{/* )} */}
			{/* {isShareEnabled && ( */}
			<Stack direction={'row'} pt={2} pb={1} alignItems={'center'} justifyContent={'space-between'} width={'100%'}>
				<Typography fontWeight={'var(--font500)'}>{language?.allowShare}</Typography>
				<CustomSwitch
					toggleEnabled={allowShare}
					handleToggleChange={(e) => handleAllowShareChange(e.target.checked)}
				/>
			</Stack>
			{/* )} */}
			{/* {(isPrivateShareEnabled || isPublicShareEnabled) && ( */}
			{/* hide visibility slider*/}
			{/* <Grid container py={1} my={1} direction={'row'} alignItems={'center'}>
				<Grid item pr={2}>
					<Typography fontWeight={'var(--font500)'}>
						{language?.visibility}
					</Typography>
				</Grid>
				<Grid item minWidth={0} xs>
					<CustomSelect size='small' fullWidth
						value={visibility?.toLowerCase()}
						onChange={handleVisibilityChange}
						MenuProps={{
							anchorOrigin : {
								vertical   : 'bottom',
								horizontal : 'left'
							},
							transformOrigin : {
								vertical   : 'top',
								horizontal : 'left'
							},
							PaperProps : {
								style : {
									maxHeight : 200,
									zIndex    : 1500
								}
							}
						}}
					>
						<MenuItem value='public'>{language?.public}</MenuItem>
						<MenuItem value='private'>{language?.private}</MenuItem>
					</CustomSelect>
				</Grid>
				<Box onClick={(e) => e.stopPropagation()} width='100%' mt={2}>
					<SelectSearchParticipants
						onParticipantsSelected={handleParticipantsSelected}
						onDepartmentsSelected={handleDepartmentsSelected}
						onRelationsSelected={handleRelationsSelected}
						initialInternalEmployees={accessControl?.internalEmployees}
						initialUserGroups={accessControl?.userGroups}
					/>
				</Box>
			</Grid> */}
			{/* )} */}
		</Grid>
	);
};

export default React.memo(AccessSlider);